type Story = {
  [chapter: string]: {
    chapter: number | string;
    music?: string;
    imagePath?: string;
    imageName?: string;
    imageFontSize?: string;
    textArray: Array<string> | null;
    options: {
      [letter: string]: {
        buttonText: string;
        goToChapter: string;
        checkpoint?: string;
      } | null;
    };
  };
};

const story: Story = {
  0: {
    chapter: 0,
    music: "Echoes_of_Time",
    textArray: [
      "A story driven visual novel adventure.",
      "☷☐☶☶☵☶☷☱☶☷☶☐☶☵",
      "DECRYPTING MESSAGE >>>",
      "☶⋀☷☱☶ Are you ready? ☷☶☐☶☵",
      "Please make your selection below",
    ],
    options: {
      a: {
        buttonText: "I'm Ready",
        goToChapter: "0b",
      },
      b: {
        buttonText: "I'm not sure",
        goToChapter: "0a",
      },
    },
  },
  "0a": {
    chapter: "0a",
    music: "Echoes_of_Time",
    textArray: [
      "Look, I don't know you but I believe in you.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You've been preparing for something like this for a long time.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Go ahead. Don't be afraid.",
    ],
    options: {
      a: {
        buttonText: "Okay, I'm Ready",
        goToChapter: "0b",
      },
      b: null,
    },
  },
  "0b": {
    chapter: "0b",
    music: "Echoes_of_Time",
    textArray: null,
    imagePath: "ascii/textImages.ts",
    imageName: "chapter1",
    imageFontSize: "0.4rem",
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "1",
      },
    },
  },
  1: {
    chapter: "1",
    music: "Echoes_of_Time",
    textArray: [
      "June 2014 ",
      "",
      "",
      "",
      "",
      "",
      "",
      "Beirut, Lebanon - American Embassy",
      "",
      "",
      "",
      "",
      "",
      "",
      "You are sitting in a windowless office in the embassy, wishing you were back in Iowa. The last two years have been pretty quiet. Mostly spent studying regional terror groups and compiling memos while you wait for your first deployment in the field.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Today has been spent reading newspapers. Taking notes on what is being written in articles and translating key points from Arabic into English. Boring, even by spy standards.",
      "",
      "",
      "",
      "",
      "",
      "",
      "... A message comes across the news wire.",
      "... ",
    ],
    options: {
      a: {
        buttonText: "Read It",
        goToChapter: "1b",
      },
      b: {
        buttonText: "Ignore It",
        goToChapter: "1c",
      },
    },
  },
  "1b": {
    chapter: "1b",
    music: "Echoes_of_Time",
    textArray: [
      "An Al-Qaeda splinter group, known as ISIS and operating out of Syria, crossed over into Iraq and attacked Mosul. Forcing the Iraqi army to retreat. They quickly took control of Iraq's second largest city.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The group also took over several highways, oil production facilities, and the majority of several provinces.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Reports of massacres are widespread.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The region is thrown into chaos.",
    ],
    options: {
      a: {
        buttonText: "View Map",
        goToChapter: "2",
      },
      b: null,
    },
  },
  "1c": {
    chapter: "1c",
    music: "Echoes_of_Time",
    textArray: [
      "You look over at the notification. Probably another banal update.",
      "You ignore it.",
      "A few moments later your colleague Alex pokes his head into your office.",
      '"Hey did you see the news? You\'re going to want to read it asap! Shit has hit the fan."',
      "Alex quickly moves onto the next office to spread the word.",
    ],
    options: {
      a: {
        buttonText: "Read the News Bulletin",
        goToChapter: "1b",
      },
      b: {
        buttonText: "Who Cares",
        goToChapter: "3",
      },
    },
  },
  2: {
    chapter: "2",
    music: "Echoes_of_Time",
    textArray: null,
    imagePath: "ascii/iraqSyria.ts",
    imageName: "iraqSyria3b",
    imageFontSize: "0.35rem",
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "3",
      },
      b: null,
    },
  },
  3: {
    chapter: "3",
    music: "Echoes_of_Time",
    textArray: [
      "The office is buzzing as everyone scrambles to make sense of the news. The CIA station chief, retired Colonel Earl Jackson, is pulled into a string of meetings. A lot for your boss, even by his standards.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Later that afternoon, his secretary calls you to his office.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Station chief Jackson explains the successful attack by ISIS was unexpected. American intelligence on this group is severely deficient and they've underestimated the terrorists' resources and ability to quickly capture large swaths of land. Human intelligence assets are not yet in place to respond to this new threat.",
      "",
      "",
      "",
      "",
      "",
      "",
      '"We need boots on the ground."',
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "3a",
      },
      b: null,
    },
  },
  "3a": {
    chapter: "3a",
    music: "Echoes_of_Time",
    textArray: [
      'You offer assistance: "Sir, what can I do to help?"',
      "",
      "",
      "",
      "",
      "",
      "",
      '"We need you to go undercover into ISIS controlled territory."',
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      '"This is what you\'ve been preparing for."',
      "",
      "",
      "",
      "",
      "",
      "",
      "Your mission will be to gather intelligence, run local sources, and work with local resistance.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Do you accept this mission?",
    ],
    options: {
      a: {
        buttonText: "Yes Sir, of course!",
        goToChapter: "4",
      },
      b: {
        buttonText: "I'm not ready...",
        goToChapter: "3b",
      },
    },
  },
  "3b": {
    chapter: "3b",
    music: "Echoes_of_Time",
    textArray: [
      '"Listen, you\'ve been preparing for something like this for a while now."',
      "",
      "",
      "",
      "",
      "",
      "",
      "\"This is what you came to Beirut to do and you're the best person for the job. You know the language, you know the culture. I've read your briefs. You know more about these guys than anyone in this building.\"",
      "",
      "",
      "",
      "",
      "",
      "",
      '"There isn\'t another option."',
      "",
      '"...We need you."',
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      '"Understand?"',
    ],
    options: {
      a: {
        buttonText: "Yes Sir",
        goToChapter: "4",
      },
      b: null,
    },
  },
  4: {
    chapter: "4",
    music: "Echoes_of_Time",
    textArray: [
      "2 Weeks Later ",
      "",
      "",
      "",
      "",
      "",
      "",
      "Beirut ",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "You find yourself in a meeting with the station chief and senior bureau staff discussing the final details of the mission.",
      "",
      "",
      "",
      "",
      "",
      "",
      "ISIS's defacto capital is located in the Syrian city of Raqqa. They have complete control of that part of the country. Which is why you will be deployed there.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You will fly into Baghdad then travel across the desert into Syria where you will setup your fake identity and begin intelligence operations.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You have two options to get into Raqqa. You can go undercover as a civilian or you can be smuggled in.",
    ],
    options: {
      a: {
        buttonText: "Smuggled",
        goToChapter: "6",
      },
      b: {
        buttonText: "Undercover",
        goToChapter: "5",
      },
    },
  },
  5: {
    chapter: "5",
    music: "Echoes_of_Time",
    textArray: [
      "You're provided the details of your cover. You will pose as a freelance journalist for an online news organization. You're supplied with fake documents, credentials, and journalism equipment.",
      "",
      "",
      "",
      "",
      "",
      "",
      "A few days later, you're flown into an American base in Baghdad. It's a hot, hectic city, and tension hangs in the air.  Your local driver picks you up to begin the 4 hour drive to the Syrian border.",
      "",
      "",
      "",
      "",
      "",
      "",
      "As you near the border crossing, you notice your driver is becoming increasingly anxious. He tells you not to speak.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Your documents are passed to a military officer, who then disappears for what feels like ages.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "The officer re-appears, and waves you over for additional questioning.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "5a",
      },
      b: null,
    },
  },
  "5a": {
    chapter: "5a",
    music: "Echoes_of_Time",
    textArray: [
      "You're escorted into a small cement building, and seated in what appears to be the Commander's office.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The driver is taken into a separate room.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "The Commander enters, and starts asking questions.  There seems to be a strong interest in your employment, your intentions, and your previous work as a journalist in the area.",
      "",
      "",
      "",
      "",
      "",
      "",
      "He ominously declares he needs to make a few phone calls before you're allowed to enter Syria.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "One hour passes.  The room is becomes stifling.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Two hours.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "An armed soldier enters the room...",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "5b",
      },
      b: null,
    },
  },
  "5b": {
    chapter: "5b",
    music: "Echoes_of_Time",
    textArray: [
      "The soldier extends out his arm. You look down to see your paperwork.",
      '"You\'re free to pass."',
      "",
      "",
      "As you get up to leave, you graciously thank him.",
      "The solider wishes you luck on your journey.",
      "",
      "",
      'You ask yourself, "how much do they really know?"',
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "5c",
      },
      b: null,
    },
  },
  "5c": {
    chapter: "5b",
    music: "Echoes_of_Time",
    textArray: [
      "Back on the road, you're able to relax again.  You're now in Syria, but still several hours away from the safe house.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Finally, as you reach the city limits, the sky darkens, and the traffic is beginning to increase.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "The driver insists that it's already late in the day, and it's unsafe to be driving at this hour. Luckily the safe house is nearby.",
      "",
      "",
      "",
      "",
      "",
      "",
      "With your awareness on high, you realize the car behind you is the same one you saw hours earlier.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Could it be another traveler making the same trek? Or a tail sent to follow you?",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Do you tell the driver to lose the tail, or proceed directly to the safe house?",
    ],
    options: {
      a: {
        buttonText: "Directly to Safe House",
        goToChapter: "8a",
      },
      b: {
        buttonText: "Lose the Tail",
        goToChapter: "8b",
      },
    },
  },
  8: {
    chapter: "8",
    music: "Echoes_of_Time",
    textArray: [
      "The truck is now back on the highway. Unfortunately for you, several hours remain until you reach the safe house. All the while you are stuck in an incredibly uncomfortable compartment with no access to a toilet.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "The truck stops at several checkpoints along the way, luckily without issue.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Even during wartime, it's common for truck drivers to drive back and forth between hostile territories to make deliveries.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "8c",
      },
      b: null,
    },
  },
  "8a": {
    chapter: "8a",
    music: "Echoes_of_Time",
    textArray: [
      "You're tired - and you know each minute spent driving the streets increases the chance of running into a checkpoint.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "You don't want to be captured before your mission even begins.",
      "",
      "",
      "",
      "",
      "",
      "",
      "So you tell the driver to take you directly to the safe house.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Finally, under the light of the moon you arrive. The building is a 2 story cement building, located on a cramped, but relatively quiet residential street. A local fixer has secured a second floor apartment for you.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Exhausted,  hungry,  and dehydrated, you look around your surroundings before climbing the stairs to the apartment and preparing for bed.",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "9",
      },
      b: null,
    },
  },
  "8b": {
    chapter: "8b",
    music: "Echoes_of_Time",
    textArray: [
      "You direct the driver to lose the tail.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You're driver protests, he's tired doesn't want to deal with the hassle. However, you know that sloppiness is what gets agents caught.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The driver turns off the busy street. Drives hastily down a side street then loops around in the opposite direction.",
      "",
      "",
      "",
      "",
      "",
      "",
      "No regular person would be taking this route and before long you've lost the possible tail and are alone again. The driver proceeds to the safe house.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You arrive around midnight. The building is a 2 story cement building, located on a cramped, but relatively quiet residential street.  A local fixer has secured a second floor apartment for you.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Exhausted,  hungry,  and dehydrated, you survey the area before climbing the stairs to the apartment and prepare for bed.",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "10",
      },
      b: null,
    },
  },
  "8c": {
    chapter: "8",
    music: "Echoes_of_Time",
    textArray: [
      "At last the truck comes to it's final stop and you hear the driver tap three times. Your legs are so stiff you almost collapse as you try to stand.",
      "",
      "",
      "",
      "",
      "",
      "",
      "It's midnight and you've finally arrived. The building is a 2 story cement building, located on a cramped, but relatively quiet residential street. A local fixer has secured the second floor apartment for you.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Exhausted,  hungry,  and dehydrated, you survey your surroundings before climbing the stairs to the apartment and preparing for bed.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "10",
      },
      b: null,
    },
  },
  9: {
    chapter: "9",
    music: "Echoes_of_Time",
    textArray: [
      "You are awoken in the middle of the night by pounding on the metal door.",
      "",
      "",
      "",
      "",
      "",
      "",
      "No one is supposed to even know you're here! You remain quiet.",
      "",
      "",
      "",
      "",
      "",
      "",
      "However they don't go away and it doesn't take them long to break down the door and armed men rush into your room.",
      "",
      "",
      "",
      "",
      "",
      "",
      "There is nowhere to go. You give yourself up without a fight.",
      "",
      "",
      "",
      "",
      "",
      "",
      "One of men quips that it's curious a supposed journalist is not staying at any of the hotels all the other journalists use.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You say nothing. You are arrested under suspicion of espionage and sent to prison.",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Back",
        goToChapter: "5b",
      },
      b: {
        buttonText: "Continue",
        goToChapter: "prison",
        checkpoint: "5b",
      },
    },
  },
  6: {
    chapter: "6",
    music: "Echoes_of_Time",
    textArray: [
      "You're provided the details of the insertion. You will be smuggled into Syria and blend amongst the locals. You're supplied with fake documents, credentials, clothes, and training on local customs, traditions, and dialect.",
      "",
      "",
      "",
      "",
      "",
      "",
      "A month later, you fly into an American base in Baghdad. It's a hot, hectic city, and tension hangs in the air. Your driver arrives and shows you the hidden compartment you'll be in during the 4 hour journey to the Syrian border.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You reluctantly pile into the false gas tank on the large fruit truck that's filled with watermelons. You're told to not speak or make any sounds anytime the vehicle is stopped.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "...",
      "Several bumpy hours go by before you feel the truck slow down and then come to a rest.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "7",
      },
      b: null,
    },
  },
  7: {
    chapter: "7",
    music: "Echoes_of_Time",
    textArray: [
      "The vehicle comes to a stop. The driver turns off the engine and gets out. You can hear orders being shouted by soldiers.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The driver explains he is taking the watermelons to be sold at the market. The solider sounds suspicious. You hear him insisting on an thorough inspection and unloading of the vehicle.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The driver protests, saying that he's in a hurry and has made this trip dozens of times before with no issues. You tense up.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "The solider goes quiet for a moment, before asking how much these watermelons will sell for. The driver, wise to fact the solider is fishing for a bribe, offers to pay $50 as a watermelon tax. The solider gladly accepts and tells the driver to get on his way.",
      "",
      "",
      "",
      "",
      "",
      "",
      "A wave of relief floods over you as the engine starts and you feel the wheels begin to roll forward.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "8",
      },
      b: null,
    },
  },
  10: {
    chapter: "10",
    music: "Echoes_of_Time",
    textArray: [
      "You wake up the next morning.",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "All you have in the apartment are the possessions given to you at the embassy before departing, equipment to send and receive transmissions, and the furniture that came with the apartment. You check the fridge. It's empty.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You were told to sit tight and wait for a local asset to make contact. When the asset is ready to meet, they are supposed to leave a mark on the garden wall across from your building.",
      "",
      "",
      "",
      "",
      "",
      "",
      "In the meantime, you consider going to the market to get food and scout the surrounding area.",
    ],
    options: {
      a: {
        buttonText: "Go to the Market",
        goToChapter: "10b",
      },
      b: {
        buttonText: "Stay Inside",
        goToChapter: "10a",
      },
    },
  },
  "10a": {
    chapter: "10a",
    music: "Echoes_of_Time",
    textArray: [
      "After spending most of yesterday crossing the desert, your skin is filthy and you smell of petrol. You decide to take a shower and clean up. Besides, the last thing you want is to attract any unwanted attention once you step outside.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Luckily, you were left a change of clothes. Perfect, this will help you blend in with the locals. Although some younger men like to wear western clothing such as jeans, if you went out in yesterday's clothes it would quickly give you away.",
      "",
      "",
      "",
      "",
      "",
      "",
      "As for the rest of your appearance, you're dark haired with olive skin. You can pass as a local to the unsuspecting gaze and your arabic is fluent after years of training including in regional dialects.",
    ],
    options: {
      a: {
        buttonText: "Walk to the Market",
        goToChapter: "11",
      },
      b: null,
    },
  },
  "10b": {
    chapter: "10b",
    music: "Echoes_of_Time",
    textArray: [
      "You take some of the local currency given to you and head out on foot. Twenty minutes later you arrive at an open air market which lines the narrow and winding street with vendors selling everything from fruit, to olive oil soap, to cellphones and knockoff electronics",
      "",
      "",
      "",
      "",
      "",
      "",
      "You buy some food as you casually walk around. You notice that many people get quiet as they walk past the ISIS fighters standing guard on most corners. Anyone unlucky enough to catch their eye is harassed about their beard or outfit. Some stall owners begin to eye you closely as you walk by.",
      "",
      "",
      "You finish shopping and return to your apartment without incident.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "10c",
      },
    },
  },
  "10c": {
    chapter: "10c",
    music: "Echoes_of_Time",
    textArray: [
      "An hour later, a trio of local ISIS fighters appear at your door. You had foolishly forgot to change into street clothes before heading out.",
      "",
      "",
      "",
      "Someone must have noticed the American style clothing while you were at the market and notified the ISIS guards.",
      "",
      "",
      "",
      "",
      "",
      "You plead your innocence but the fighters aren't listening. They search your apartment and find your transmission equipment.",
      "",
      "",
      "You are arrested and taken to jail.",
    ],
    options: {
      a: {
        buttonText: "Back",
        goToChapter: "10",
      },
      b: {
        buttonText: "Continue",
        goToChapter: "prison",
        checkpoint: "10",
      },
    },
  },
  11: {
    chapter: "11",
    music: "Echoes_of_Time",
    textArray: [
      "You take some of the local currency given to you and head out on foot. Twenty minutes later you arrive at an open air market which lines the narrow and winding street with vendors selling everything from fruit, to olive oil soap, to cellphones and knockoff electronics",
      "",
      "",
      "",
      "",
      "",
      "",
      "You buy some food as you casually walk around. You notice that many people get quiet as they walk past the ISIS fighters standing guard on most corners. Anyone unlucky enough to catch their eye is harassed about their beard or outfit.",
      "",
      "",
      "You pretend to be preoccupied by your shopping as you walk by. Luckily they don't pay you any attention. The agency's technical service teams always pick out simple but effective disguises.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "11a",
      },
      b: null,
    },
  },
  "11a": {
    chapter: "11a",
    music: "Echoes_of_Time",
    textArray: [
      "You finish your shopping, keeping mental notes on everything you saw. Including the number of fighters, their weaponry, general locations, and any chatter you overheard from both guards and locals.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You return to the safe house on foot. The wall doesn't have any markings yet.",
      "",
      "",
      "You go back to your apartment and transmit the day's events back to your handlers.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "12",
      },
    },
  },
  12: {
    chapter: "12",
    music: "Echoes_of_Time",
    textArray: [
      "The Next Day",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Your objectives include to note troop movements, the locations of  military defenses, bases, and any other useful military information. You also need to collect HUMINT, spy speak for information collected from human sources.",
      "",
      "",
      "",
      "While you wait for the asset to make contact you decide to do more reconnaissance.",
      "",
      "",
      "",
      "You head out on foot and travel to the historic old town, careful to avoid checkpoints. Security is high. You also observe fighters on many intersections as well as pick-up trucks with turrets mounted on the back patrolling the roads.",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "12a",
      },
    },
  },
  "12a": {
    chapter: "12a",
    music: "Echoes_of_Time",
    textArray: [
      "However, the CIA can see all this using satellites and drones flying far overheard.",
      "",
      "",
      "",
      "",
      "",
      "",
      "What's truly valuable is understanding the sentiment of the locals. Western governments are keen to know how much support ISIS has from the local and whether they'd be cooperative in helping drive out the terrorists.",
      "",
      "",
      "",
      "",
      "",
      "",
      "ISIS has only been in power a few weeks but the return of vital services such as electricity and water has some civilians applauding there presence. Those attitudes will likely change over time as ISIS clamps down on the locals.",
    ],
    options: {
      a: {
        buttonText: "Talk to the Locals",
        goToChapter: "12b",
      },
      b: {
        buttonText: "Keep to Yourself",
        goToChapter: "12d",
      },
    },
  },
  "12b": {
    chapter: "12b",
    music: "Echoes_of_Time",
    textArray: [
      "You try to strike up conversations with vendors at the market with innocent questions.",
      '"Are you finding it hard to keep supplies stocked?"',
      "As expected, most aren't willing to say anything even close to negative about the regime. Their reputation for killing dissenters has spread quickly.",
      "",
      "",
      "",
      "",
      "",
      "",
      "Some begin to speak honestly but quickly hush up. Others go into long tirades against America. After a few conversations your spine begins to tingle. Behind you, one of the stall owners you approached earlier is talking to a fighter and pointing in your direction.",
    ],
    options: {
      a: {
        buttonText: "Escape",
        goToChapter: "12c",
      },
    },
  },
  "12c": {
    chapter: "12c",
    music: "Echoes_of_Time",
    textArray: [
      "You walk in the opposite direction but the fighter begins to follow you.",
      "",
      "He shouts at you through the crowd to stop.",
      "",
      "Ignoring him, you turn down into an alleyway before breaking into a sprint. You run down the back street but now you can hear multiple voices calling after you. You reach a t-junction in the alley.",
      "",
      "Do you go left or right?",
    ],
    options: {
      a: {
        buttonText: "Go Left",
        goToChapter: "12e",
      },
      b: {
        buttonText: "Go Right",
        goToChapter: "12f",
      },
    },
  },
  "12d": {
    chapter: "12d",
    music: "Echoes_of_Time",
    textArray: [
      "You'd love nothing more than to delve deep into conversation with some locals, but once again your training and instincts kick in. You realize that approaching strangers on the street in a busy market is not the right approach. Most people would assume you're trying to arrest enemies of the regime and wouldn't even bother talking to you.",
      "",
      "",
      "",
      "",
      "",
      "",
      "It'd be better if you were somewhere where conversation about things, including politics, occurs organically. Maybe one of the cafes that still remain. However, that will have to wait for another day. You decide to head back and check to see if the asset has made contact yet.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You return to the safe house, still nothing. You're surprised it has taken this long but it's not unheard of.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You prepare your report and transmit your day's findings. Maybe you'll go to a cafe tomorrow.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "13",
      },
    },
  },
  "12e": {
    chapter: "12e",
    music: "Echoes_of_Time",
    textArray: [
      "Both directions look the same and neither exit onto the street so you turn left and run like the wind.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You zig-zag down the alley before you run out of options and find yourself at a dead-end. You try the door to some apartments but all are locked and the metal doors don't have windows.",
      "",
      "",
      "The fighters soon catch up to you.",
      "",
      "",
      "",
      "The gig is up. You should have known better than to approach people on the street.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You are arrested and taken to jail. At best you'll be tried as a dissident. At worst, you'll be hung as a spy.",
    ],
    options: {
      a: {
        buttonText: "Back",
        goToChapter: "12c",
      },
      b: {
        buttonText: "Continue",
        goToChapter: "prison",
        checkpoint: "12c",
      },
    },
  },
  "12f": {
    chapter: "12f",
    music: "Echoes_of_Time",
    textArray: [
      "Both directions look the same and neither exit onto the street so you turn right and hope for an escape.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You zig-zag down the narrow alleyways, looking for an open door or exit onto the street. You've almost run out of options as you keep encountering dead ends before finally rounding a corner and finding yourself back on a busy market street.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You hand a merchant a large bill and grab a shirt and hat. Your training kicks in and you quickly disappear into the crowd.",
      "",
      "",
      "You make it back to your apartment, breathing a sigh of relief. You tell yourself you won't make a mistake like that again.",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "13",
      },
    },
  },
  13: {
    chapter: "13",
    music: "Echoes_of_Time",
    textArray: [
      "It's been several days but the local asset still hasn't signaled they are ready to meet. Your gut is telling you something is wrong. But you've also learned to trust your training and not make rash decisions. Maybe the asset is simply being cautious and waiting until it's safe to make contact.",
      "",
      "",
      "",
      "",
      "",
      "",
      "In the meantime, you have been busy transmitting plenty of details back to HQ. Intelligence gathered from discreet scouting walks through town. Restaurants and Cafes have always been one of the most common and reliable locations where intel is gathered, dating back to the earliest days of espionage.",
      "",
      "",
      "",
      "",
      "",
      "",
      "In the dossier you memorized before deployment, a nearby cafe were highlighted as a potential spot frequented by the locals. You recite your cover story to yourself one more time then head out on foot.",
    ],
    options: {
      a: {
        buttonText: "Walk to Cafe",
        goToChapter: "13a",
      },
      b: null,
    },
  },
  "13a": {
    chapter: "13a",
    music: "Echoes_of_Time",
    textArray: [
      "20 Minutes Later",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "You find yourself sitting in stiff but padded wooden chair across from an older man with a greying beard in a partially shaded cafe surrounded by the sounds of dice being thrown and pips emphatically moved across backgammon boards. Without being prompted, a waiter comes up and places a small cup of hot tea in front of you. As if one would ever drink anything else, even in the sweltering heat.",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Talk to the old Man",
        goToChapter: "13b",
      },
    },
  },
  "13b": {
    chapter: "13b",
    music: "Echoes_of_Time",
    textArray: [
      "A backgammon board on the table separates you and the elderly man. Before long, you're deep into your third game with the man, whose luck comes and goes but not his vigor for calling out the values of each dice roll. You overhear some conservations amongst the regulars about the recent capture of Iraqi cities but nothing too important.",
      "",
      "",
      "",
      "",
      "Most of the men seem indifferent to the ongoings of ISIS and would rather fixate on gambling and socializing. Only a few of the men leave to pray. Most of the devout men no longer come to the cafe, fearing that the moral police would not look kindly on men gambling and forgoing their prayers.",
    ],
    options: {
      a: {
        buttonText: "Check the Time",
        goToChapter: "14",
      },
      b: {
        buttonText: "Leave",
        goToChapter: "14",
      },
    },
  },
  14: {
    chapter: "14",
    music: "Echoes_of_Time",
    textArray: [
      "",
      "",
      "",
      "",
      "",
      "",
      "You check the time. Realizing the sun will set in the next hour you decide to wrap things up and thank the older man for his company.",
      "",
      "",
      "",
      "",
      "",
      "",
      "You waive for your bill and a large middle-aged man walks up to you with a large smile. He introduces himself as the owner of the cafe and thanks you for visiting his cafe. You can tell by his body language he knows you're not a local. Hopefully he thinks you're just vising family.",
      "",
      "",
      "",
      "",
      "",
      "",
      "He asks you a couple innocuous questions about where you're from and seems to accept your pre-meditated answers with a smile. As you both walk towards the exit he asks if there is anything you need, maybe something to eat, or a place to stay. You politely decline but reaffirms his offer for lodging, letting you know he has an apartment above the cafe that is available. You politely decline once again before shaking hands and heading off.",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Walk Home",
        goToChapter: "15",
      },
      b: null,
    },
  },
  15: {
    chapter: "15",
    music: "Echoes_of_Time",
    textArray: [
      "20 minutes later",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "You stop at the corner of your apartment building. You were told that the local asset would signal he'd like to meet the following day by leaving an omega symbol nearby. Across the street, on the short wall surrounding the building is a symbol drawn in chalk. The greek letter omega. The signal means it's time to to meet them at the predetermined location the next day at 10am.",
      "",
      "",
      "",
      "",
      "",
      "",
      "However your intuition is telling you there is a problem. Your handlers were clear that you were looking for an uppercase omega symbol but the wall shows the more commonly used lower-case omega. The one commonly found in math textbooks and popular culture. Maybe the local asset is just being careless, it wouldn't be the first time.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "15c",
      },
    },
  },
  "15c": {
    chapter: "15c",
    music: "Echoes_of_Time",
    textArray: [
      "",
      "Your gut is telling you something is wrong... or maybe you're just being paranoid. Either way, you'll have until tomorrow to decide",
      "",
      "",
      "",
      "",
      "You take a walk around the neighborhood looking for anything out of place. You don't notice any surveillance so you climb over the back fence and discreetly slip into the apartment building.",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Meet with the Asset",
        goToChapter: "15b",
      },
      b: {
        buttonText: "Skip the meeting",
        goToChapter: "15a",
      },
    },
  },
  "15a": {
    chapter: "15a",
    music: "Echoes_of_Time",
    textArray: [
      "As with most things in the espionage world, it is expected that sometimes signals, dead-drops, and meetings will be missed. Although you've been waiting all week for this asset to finally make contact, it won't be the end of the world if you miss the first meeting. He may even think you've been captured, but a good asset will be patient and keep trying. Hopefully he gets the right symbol the next time.",
      "",
      "",
      "",
      "",
      "",
      "",
      "As you sit in bed thinking. You realize that if an asset is sloppy enough to use the wrong symbol they'll also be sloppy enough to get caught. So either they are about to slip up and get you caught or they've already been caught and you're compromised.",
    ],
    options: {
      a: {
        buttonText: "Remain Calm",
        goToChapter: "15d",
      },
      b: {
        buttonText: "Jump into Action",
        goToChapter: "15d",
      },
    },
  },
  "15d": {
    chapter: "15d",
    music: "Echoes_of_Time",
    textArray: [
      "",
      "Regardless of what's actually happening, you're not going to take any chances. If the asset is compromised and this is some kind of trap, they could show up at any minute.",
      "",
      "",
      "It's best to assume you've been compromised.",
      "",
      "You pack all the documents and espionage equipment before quietly slipping out the building by jumping over the back wall again. You disappear into the night.",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "16",
      },
      b: null,
    },
  },
  "15b": {
    chapter: "15b",
    music: "Echoes_of_Time",
    textArray: [
      "",
      "",
      "",
      "",
      "",
      "",
      "You lay in bed that night debating what to do.",
      "",
      "",
      "Who knows how long it will be before you receive another signal. Without this asset, you won't accomplish much and your mission will be a failure.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The next morning, you show up early to the meeting place, a quiet street near a empty construction site. You aren't being tailed and don't notice much surveillance.",
    ],
    options: {
      a: {
        buttonText: "Wait for the Asset",
        goToChapter: "15e",
      },
    },
  },
  "15e": {
    chapter: "15e",
    music: "Echoes_of_Time",
    textArray: [
      "",
      "",
      "",
      "",
      "",
      "",
      "A taxi approaches and a man gets out and walks towards you with a large smile.",
      "He is wearing an immaculate black robe with a prayer cap and sporting a long beard. Either your asset is posing as a deeply religious man or this is someone from the religious police, the defacto ISIS intelligence service.",
      "",
      "This development and the mixup of the symbols surely couldn't be a coincidence! You walk past the man, pretending to not even notice him. You hope he mistakes you for a passerby.",
      "",
      "",
      "",
      "",
      "To your horror he calls out after you. You break into a sprint. A block down, armed men start appearing from every direction. This was all a setup. The asset was compromised. You are arrested and taken to jail.",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Back",
        goToChapter: "15",
      },
      b: {
        buttonText: "Continue",
        goToChapter: "prison",
        checkpoint: "15",
      },
    },
  },
  16: {
    chapter: "16",
    music: "Echoes_of_Time",
    textArray: [
      "",
      "",
      "",
      "",
      "",
      "",
      "You spend the night at a cheap hotel that didn't ask too many questions they saw your cash. The next day you discreetly return to your apartment building. As you near the building, you stop dead in your tracks and your face goes pale...",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "A pickup truck with two militants are standing guard in front of your building. You watch from a distance as four men kick in the door to your apartment. You stare in disbelief as you watch the safe-house get raided. Had you stayed last night, you would have been captured.",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Continue",
        goToChapter: "16b",
      },
      b: null,
    },
  },
  "16b": {
    chapter: "16b",
    music: "Echoes_of_Time",
    textArray: [
      "A crowd begins to gather. Meanwhile your mind is racing.",
      "The only ones that knew about the safe-house are the folks at HQ and the local asset. It's unlikely ISIS would have moles within the CIA feeding them information. Typically that only powerful state actors were capable of such coups.",
      "",
      "",
      "",
      "",
      "",
      "",
      "The only other possibility is the asset. They must have been compromised. If they were captured, beaten, and tortured, it's entirely possible they gave up your location and the symbol to use to signal a meeting. That would explain why the incorrect symbol had been used and why there was such a long pause before contact was made.",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    options: {
      a: {
        buttonText: "Disappear",
        goToChapter: "16a",
      },
      b: null,
    },
  },
  "16a": {
    chapter: "16a",
    music: "Echoes_of_Time",
    textArray: [
      "",
      "",
      "",
      "",
      "",
      "",
      "Knowing there isn't anything you can do now, you disappear amongst the crowd.",
      "",
      "",
      "",
      "",
      "",
      "",
      "No sense focusing on what's out of your hands. Your training tells you to move on and act quickly in the face of catastrophe.",
      "",
      "",
      "You need to figure out where you will stay now. Unfortunately ISIS will be checking all the local hotels once they realize you've slipped through their fingers.",
    ],
    options: {
      a: {
        buttonText: "Talk to the Cafe Owner",
        goToChapter: "17a",
      },
      b: {
        buttonText: "Don't trust anyone",
        goToChapter: "17b",
      },
    },
  },
  prison: {
    chapter: "prison",
    music: "Scraping_The_Sewer",
    textArray: null,
    imagePath: "ascii/textImages.ts",
    imageName: "prison1",
    imageFontSize: "1rem",
    options: {
      a: null,
      b: {
        buttonText: "Main Menu",
        goToChapter: "0",
      },
    },
  },
  TBD: {
    chapter: "TBD",
    music: "Echoes_of_Time",
    textArray: null,
    imagePath: "TBD",
    imageFontSize: "1rem",
    options: {
      a: {
        buttonText: "Main Menu",
        goToChapter: "0",
      },
      b: null,
    },
  },
};

export default story;
